import React from 'react';
import clsx from 'clsx';
import { EllipsisVertical, GripVertical, TicketPercent } from 'lucide-react';
import { ROOT_CONTAINER, DISCOUNT_CODE_ITEM_ID } from '@repo/lib';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@dashboard/components/ui/dropdown-menu';
import { Button as ShadcnButton, buttonVariants } from '@dashboard/components/ui/button';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@dashboard/components/ui/accordion';
import DiscountCodeForm from '../../../scenes/PageSettings/components/DiscountCodeForm';
import MoveToMenu from './MoveToMenu';
import DisabledBadge from './DisabledBadge';
import { useFormLayout } from '../FormLayoutContext';

export default function DiscountCodeItem({
  item,
  dragHandleProps,
  containerId = ROOT_CONTAINER,
  disabled,
}) {
  const { removeDiscountCode, discountCodeDisabled, setDiscountCodeDisabled } = useFormLayout();
  const value = `discount-code:${item.id ?? DISCOUNT_CODE_ITEM_ID}`;

  return (
    <AccordionItem value={value} className="border-b-0" data-testid="discount-code-row">
      <div className="flex flex-row items-center gap-2 px-1">
        <div
          {...dragHandleProps}
          className={clsx(
            buttonVariants({ variant: 'ghost', size: 'icon' }),
            'cursor-grab active:cursor-grabbing',
          )}
        >
          <GripVertical className="size-4" />
        </div>
        <div className="flex-1 min-w-0">
          <AccordionTrigger className="py-3 min-w-0 items-center hover:no-underline">
            <div className="flex min-w-0 gap-x-2 items-center">
              <TicketPercent className="size-4 shrink-0" aria-hidden="true" />
              <div className={clsx('truncate min-w-0', { 'opacity-60': discountCodeDisabled })}>
                Discount code
                {discountCodeDisabled && <DisabledBadge />}
              </div>
            </div>
          </AccordionTrigger>
        </div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild disabled={disabled}>
            <ShadcnButton variant="ghost" size="icon" aria-label="More options" disabled={disabled}>
              <EllipsisVertical className="size-4" />
            </ShadcnButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <MoveToMenu itemKey={value} currentContainerId={containerId} />
            <DropdownMenuItem onSelect={() => setDiscountCodeDisabled(!discountCodeDisabled)}>
              {discountCodeDisabled ? 'Enable' : 'Disable'}
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem variant="destructive" onSelect={() => removeDiscountCode()}>
              Delete
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <AccordionContent className={clsx('pb-4 pt-2', { 'px-3': containerId !== ROOT_CONTAINER })}>
        <DiscountCodeForm />
      </AccordionContent>
    </AccordionItem>
  );
}
